import React from 'react';
import { Header4 } from '../../../shared/Headers';
import styled from 'styled-components/macro';

type Props = {
  notes: string | null;
};

export const SalesOrderNotes = ({ notes }: Props) => {
  if (notes == null) {
    return null;
  }

  return (
    <>
      <Header4>Sales Order Notes</Header4>
      <NotesText>{notes}</NotesText>
    </>
  );
};

const NotesText = styled.div`
  white-space: pre;
`;
